import http from './http';

/// Musteri
export function getMusteri() {
    return http.get(`/musteri`);
}

export function getMusteriDetail(id) {
    return http.get(`/musteri/detail/${id}`);
}

export function getMusteriKontrolGecmisi() {
    return http.get(`/musteri/kontrolGecmisi`);
}

export function getMusteriGunlukKontroller(day) {
    return http.get(`/musteri/gunKontrolleri/${day}`);
}

export function toggleMusteriAktif(id, aktif) {
    return http.put(`/musteri/aktif/${id}/${ aktif }`);
}

export function toggleMakinalarCalismiyor(id, makinalarCalismiyor) {
    return http.put(`/musteri/makinalarCalismiyor/${id}/${makinalarCalismiyor}`);
}

export function createMusteri(data) {
    return http.post(`/musteri/create`, data);
}

export function updateMusteri(id, data) {
    return http.put(`/musteri/update/${id}`, data);
}

export function updateMusteriKontrolZamani(id, data) {
    return http.put(`/musteri/update/${id}/kontrolZamani`, data);
}

export function deleteMusteri(id) {
    return http.delete(`/musteri/delete/${id}`);
}
